import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";
import { getAllSubscriptionPlan } from "../../services/api/subscription";
import {
  INDIAN_RUPEE_SIGN,
  RENTLY_HOME_ICON_COLOR,
} from "../../constant/constant";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";

const SubscriptionPlanStep = ({ registerData, setRegisterData, dispatch }) => {
  const [subscriptionOptions, setSubscriptionOptions] = useState([]);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await getAllSubscriptionPlan();
        setSubscriptionOptions(response.data);
      } catch (error) {
        dispatch(showToast({ message: error.message, severity: "error" }));
      }
    };
    fetchSubscriptions();
  }, [dispatch]);

  const handleSelectPlan = (plan) => {
    setRegisterData((prev) => ({
      ...prev,
      subscription_plan_id: plan.id,
      plan_details: plan,
    }));
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 6,
      }}
    >
      {subscriptionOptions.map((plan) => (
        <Card
          key={plan.id}
          sx={{
            width: 300,
            border:
              registerData.subscription_plan_id === plan.id
                ? `2px solid ${RENTLY_HOME_ICON_COLOR}` // Dark black border when selected
                : "1px solid #ccc", // Default border color
            borderRadius: 2,
            boxShadow: registerData.subscription_plan_id === plan.id ? 3 : 1,
            transition: "transform 0.3s ease-in-out",
            "&:hover": { transform: "scale(1.05)" },
          }}
          onClick={() => handleSelectPlan(plan)}
        >
          <CardContent>
            <Typography variant="h5">{plan.plan_name}</Typography>
            <Typography variant="body2" color="textSecondary">
              {plan.plan_description}
            </Typography>
            <Typography
              variant="h3"
              sx={{ mt: 7, mb: 7, fontWeight: 300 }}
              color="textSecondary"
            >
              {`${INDIAN_RUPEE_SIGN} ${plan.plan_price}/mo`}
            </Typography>
            <Button
              variant={
                registerData.subscription_plan_id === plan.id
                  ? "contained"
                  : "outlined"
              }
              sx={{
                textTransform: "none",
                fontWeight: "700",
                py: 1.3,
                px: 4,
                borderRadius: 2,
                width: "100%",
                borderColor:
                  registerData.subscription_plan_id === plan.id
                    ? RENTLY_HOME_ICON_COLOR // Change border color when selected
                    : "#0067de", // Default border color
                color:
                  registerData.subscription_plan_id === plan.id
                    ? "black" // White text when selected
                    : "#0067de", // Default text color
                backgroundColor:
                  registerData.subscription_plan_id === plan.id
                    ? RENTLY_HOME_ICON_COLOR // Background color when selected
                    : "transparent", // Transparent when not selected
                marginBottom: 5,
                "&:hover": {
                  borderColor:
                    registerData.subscription_plan_id === plan.id
                      ? RENTLY_HOME_ICON_COLOR // Hover border color
                      : "#005bb5", // Hover border color when not selected
                  backgroundColor:
                    registerData.subscription_plan_id === plan.id
                      ? RENTLY_HOME_ICON_COLOR
                      : "transparent", // Hover background color
                },
              }}
            >
              Choose Plan
            </Button>
            <Divider />

            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <ApartmentIcon sx={{ mr: 1, color: "text.secondary" }} />
              <Typography variant="subtitle2">
                {`Add upto ${plan.max_buildings} buildings`}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <HomeIcon sx={{ mr: 1, color: "text.secondary" }} />
              <Typography variant="subtitle2">
                {`Add upto ${plan.max_properties} flats/properties`}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <GroupIcon sx={{ mr: 1, color: "text.secondary" }} />
              <Typography variant="subtitle2">
                {`Add upto ${plan.max_tenants} tenants`}
              </Typography>
            </Box>

            {/* <Typography variant="h6" sx={{ mt: 2 }}>
              {`Duration ${plan.duration_in_days} days`}
            </Typography> */}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default SubscriptionPlanStep;
